import { useMutation } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"
import { getSupabaseFunctionErrorMessage } from "@/utils/supabaseFunctionUtils"

/**
 * Public forgot-password request. The function answers the same way whether or not the email has
 * an account, so success here only means the request was accepted.
 */
export const useRequestPasswordReset = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      const { data, error } = await supabase.functions.invoke("request-password-reset", {
        body: { email },
      })

      if (error) {
        throw new Error(await getSupabaseFunctionErrorMessage(error))
      }

      return data as { success: boolean; message: string }
    },
  })
}
